export default __webpack_public_path__ + "static/media/projects_active.7e63dc22.svg";